import QualifiedTeacherScreen from './containers/qualifiedTeacherScreen'

export {default as QualifiedTeacherScreenLayout} from './components/qualifiedTeacherScreenLayout'

export default QualifiedTeacherScreen
